export default {
  namespaced: true,
  state: {
    creationFromDate: null,
    creationToDate: null,
    updateFromDate: null,
    updateToDate: null,
    selectedAtcs: [],
    selectedSampleTypes: [],
    selectedParameters: [],
    selectedFarms: [],
    selectedParcels: [],
    selectedStatuses: [],
    selectedValueReports: [],
  },
  actions: {
    setCreationToDate({ commit }, value) {
      commit('setCreationToDate', value);
    },
    setCreationFromDate({ commit }, value) {
      commit('setCreationFromDate', value);
    },
    setUpdateFromDate({ commit }, value) {
      commit('setUpdateFromDate', value);
    },
    setUpdateToDate({ commit }, value) {
      commit('setUpdateToDate', value);
    },
    setSelectedAtcs({ commit }, value) {
      commit('setSelectedAtcs', value);
    },
    setSelectedSampleTypes({ commit }, value) {
      commit('setSelectedSampleTypes', value);
    },
    setSelectedParameters({ commit }, value) {
      commit('setSelectedParameters', value);
    },
    setSelectedFarms({ commit }, value) {
      commit('setSelectedFarms', value);
    },
    setSelectedParcels({ commit }, value) {
      commit('setSelectedParcels', value);
    },
    setSelectedStatuses({ commit }, value) {
      commit('setSelectedStatuses', value);
    },
    setSelectedValueReports({ commit }, value) {
      commit('setSelectedValueReports', value);
    },
    clearFilters({ commit }) {
      commit('clearFilters');
    },
  },
  mutations: {
    setCreationFromDate(state, value) {
      state.creationFromDate = value;
    },
    setCreationToDate(state, value) {
      state.creationToDate = value;
    },
    setUpdateFromDate(state, value) {
      state.updateFromDate = value;
    },
    setUpdateToDate(state, value) {
      state.updateToDate = value;
    },
    setSelectedAtcs(state, value) {
      state.selectedAtcs = value;
    },
    setSelectedParameters(state, value) {
      state.selectedParameters = value;
    },
    setSelectedFarms(state, value) {
      state.selectedFarms = value;
    },
    setSelectedSampleTypes(state, value) {
      state.selectedSampleTypes = value;
    },
    setSelectedParcels(state, value) {
      state.selectedParcels = value;
    },
    setSelectedStatuses(state, value) {
      state.selectedStatuses = value;
    },
    setSelectedValueReports(state, value) {
      state.selectedValueReports = value;
    },
    clearFilters(state) {
      state.creationFromDate = null;
      state.creationToDate = null;
      state.updateFromDate = null;
      state.updateToDate = null;
      state.selectedAtcs = [];
      state.selectedParameters = [];
      state.selectedSampleTypes = [];
      state.selectedFarms = [];
      state.selectedParcels = [];
      state.selectedStatuses = [];
      state.selectedValueReports = [];
    },
  },
};
